import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Tailoring.css";

const Tailoring = () => {
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [users, setUsers] = useState([]); // Store fetched users
  const [viewdatas,setViewdatas] = useState(null)
  const [view, setView] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    relationship: "",
    fatherHusbandName: "",
    doorNumber: "",
    streetName: "",
    postalArea:"",
    district: "",
    taluk: "",
    pinCode: "",
    aadharNumber: "",
    courseName: "",
    photo: null,
  });

 const [dropdata,setDropdata]=useState([])

 const [submitError, setSubmitError] = useState(""); 

  useEffect(() => {
    fetchUsers();
    drop();
  }, []);

  const fetchUsers = async () => {
    try {
      const userID = localStorage.getItem("UserId"); // Get userID from localStorage
  
      const response = await axios.get(`${process.env.REACT_APP_API}/tailoring/getUsers`);
  
      // Filter users where response.data.userID matches localStorage userID
      const filteredUsers = response.data.filter((user) => user.userID === userID);
  
      setUsers(filteredUsers);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };
  
  


const drop = async () => {
  const userid = localStorage.getItem("UserId");
  console.log("UserID:", userid);

  try {
    const response = await axios.get(`${process.env.REACT_APP_API}/tailoring/drop/${userid}`);
    const institutionType = response.data[0]?.institutionType;
    console.log("Fetched Institution Type:", institutionType);

    if (institutionType === "Tailoring Institution") {
      setDropdata([
        "Aari Works and Designing",
        "Tailoring and Embroidery",
        "Embroidery",
        "Tailoring"
      ]);
    } else if (institutionType === "Beautician Course") {
      setDropdata(["Beautician Course"]);
    } else if (institutionType === "Computer Education") {
      setDropdata([
        "Tally",
        "C",
        "Java",
        "PHP",
        "JavaScript",
        "Tally ERP 9",
        "Desktop Publishing (DTP)"
      ]);
    } else {
      setDropdata([]);
    }
  } catch (error) {
    console.error("Fetch error:", error);
  }
};

  const [editdata,setEditdata]=useState(null)
   const [edit,setedit]=useState(false) 
   const handleEdit = async (id) => {
    try {
      const getbyid = await axios.get(`${process.env.REACT_APP_API}/tailoring/getuser/${id}`);
      setEditdata(getbyid.data);
      setedit(true);
      if (getbyid.data.district) {
        const selectedDistrict = districts.find(d => d.name === getbyid.data.district);
        if (selectedDistrict?.id) {
          fetch(`${process.env.REACT_APP_API}/locations/taluks?district_id=${selectedDistrict.id}`)
            .then(res => res.json())
            .then(data => setTaluks(data))
            .catch(err => console.error("Error fetching taluks:", err));
        }
      }
    } catch (err) {
      console.log("Error getting details", err);
    }
  };
  

  const [photoFile, setPhotoFile] = useState(null);
const handleFileChange = (e) => {
  const { name, value, files } = e.target;

  if (name === "photo") {
    setPhotoFile(files[0]); // Save the selected file
  } else {
    setEditdata((prev) => ({
      ...prev,
      [name]: value,
    }));
  }
};


  const handleEditChange = (e) => {
    const { name, value } = e.target;
  
    setEditdata((prev) => ({
      ...prev,
      [name]: value,
    }));
  
    // If district changes, update Taluk options dynamically
    if (name === "district") {
      const selectedDistrict = districts.find(d => d.name === value);
      if (selectedDistrict?.id) {
        fetch(`${process.env.REACT_APP_API}/locations/taluks?district_id=${selectedDistrict.id}`)
          .then(res => res.json())
          .then(data => setTaluks(data))
          .catch(err => console.error("Error fetching taluks:", err));
      } else {
        setTaluks([]);
        setEditdata((prev) => ({ ...prev, taluk: "" })); // Reset taluk field if district changes
      }
    }
  };
  
  
 
  
 

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => {
    setShowModal(false);
    setFormData({
      name: "",
      relationship: "",
      fatherHusbandName: "",
      doorNumber: "",
      streetName: "",
      postalArea:"",
      district: "",
      taluk: "",
      pinCode: "",
      aadharNumber: "",
      courseName: "",
      photo: null,
    });
  };

 const handleupdate = async (e) => {
  e.preventDefault();

  const userID = localStorage.getItem("UserId");
  if (!userID) {
    alert("User ID not found! Please log in.");
    return;
  }

  const formDataToSend = new FormData();

  // Add all existing text fields
  Object.entries(editdata).forEach(([key, value]) => {
    formDataToSend.append(key, value);
  });

  // Add the photo if one was selected
  if (photoFile) {
    formDataToSend.append("photo", photoFile);
  }

  formDataToSend.append("userID", userID);

  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API}/tailoring/update/${editdata.id}`,
      formDataToSend,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    alert("User updated successfully!");
    fetchUsers();
    setedit(false);
    setEditdata(null);
    setPhotoFile(null); // Clear the selected file
  } catch (error) {
    console.error("Error updating user:", error);
    alert("Error updating user.");
  }
};

  
  const handleView = async (id) => {
    try {
      const getvalue = await axios.get(`${process.env.REACT_APP_API}/tailoring/getuser/${id}`);
      setViewdatas(getvalue.data);
      console.log(getvalue.data)
      setView(true);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  
  
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  
  //   const userID = localStorage.getItem("UserId");
  //   const formDataToSend = new FormData();
  
  //   Object.entries(formData).forEach(([key, value]) => {
  //     formDataToSend.append(key, value);
  //   });
  
  //   formDataToSend.append("userID", userID); // Add userID to the form data
  
  //   try {
  //     const response = await axios.post(
  //       `${process.env.REACT_APP_API}/tailoring/addUser`,
  //       formDataToSend,
  //       {
  //         headers: { "Content-Type": "multipart/form-data" },
  //       }
  //     );
  
  //     alert("User added successfully!");
  //     setShowModal(false);
  //           fetchUsers();
  //   } catch (error) {
  //     console.error("Error adding user:", error);
  //     alert("Error adding user.");
  //   }
  // };
  
  const handleSubmit = async (e) => {
  e.preventDefault();

  const userID = localStorage.getItem("UserId");
  const formDataToSend = new FormData();

  Object.entries(formData).forEach(([key, value]) => {
    formDataToSend.append(key, value);
  });

  formDataToSend.append("userID", userID); // Add userID to the form data

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API}/tailoring/addUser`,
      formDataToSend,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    alert("User added successfully!");
    setShowModal(false);
    fetchUsers();
    setSubmitError(""); // clear previous errors
  } catch (error) {
    console.error("Error adding user:", error);
    if (error.response && error.response.data?.error) {
      setSubmitError(error.response.data.error); // Set backend error to display
    } else {
      setSubmitError("Something went wrong. Please try again.");
    }
  }
};

  
  

  
  
  const filteredData = users.filter((user) =>
    user.name.toLowerCase().includes(search.toLowerCase())
  );


  const [districts, setDistricts] = useState([]);
  const [taluks, setTaluks] = useState([]);
   
  useEffect(() => {
    // Fetch Districts from API
    fetch(`${process.env.REACT_APP_API}/locations/districts`)
      .then((res) => res.json())
      .then((data) => setDistricts(data))
      .catch((err) => console.error("Error fetching districts:", err));
  }, []);

  useEffect(() => {
    const selectedDistrict = districts.find(d => d.name === formData.district);
  
    if (selectedDistrict?.id) {
      fetch(`${process.env.REACT_APP_API}/locations/taluks?district_id=${selectedDistrict.id}`)
        .then((res) => res.json())
        .then((data) => setTaluks(data))
        .catch((err) => console.error("Error fetching taluks:", err));
    } else {
      setTaluks([]);
    }
  }, [formData.district, districts]); 
  



  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === "file") {
      setFormData((prev) => ({ ...prev, [name]: files[0] })); // Store file properly
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };
  

  return (
    <div className="tailoring-container">
      <h2>Tailoring</h2>

      {/* Search Bar */}
      <div className="search-container">
        <input
          type="text"
          placeholder="Search..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <button className="add-btn" onClick={handleOpenModal}>
          + Add
        </button>
      </div>

      {/* Table */}
      <table>
        <thead>
          <tr>
            <th>S No</th>
            <th>Name</th>
            <th>Course Name</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
  {filteredData
    .sort((a, b) => {
      if (a.status === "Re Submit") return -1; // "Re Submit" at the top
      if (a.status === "Pending" && b.status !== "Re Submit") return -1; // "Pending" below "Re Submit"
      return 1; // Others remain at the bottom
    })
    .map((user, index) => (
      <tr key={user.id}>
        <td>{index + 1}</td>
        <td>{user.name}</td>
        <td>{user.courseName}</td>
        <td className="status" style={{ color: user.status === "Re Submit" ? "red" : "green" }}>
          {user.status || "Pending"}
        </td>
        <td>
          {user.status!=='Approved'&&<button className="resubmit-btn" onClick={() => handleEdit(user.id)}> {user.status === 'Re Submit' ? "Resubmit" : "Edit"}</button>}
          <button  className="view-btn" onClick={() => handleView(user.id)}>View</button>
          {/* <a download href={`${process.env.REACT_APP_API}/uploads/Categories/${viewdatas?.photo}`} >{user.certificate_path}</a> */}
          {user.status === 'Approved' && user.photo&&  (
  <a 
    download 
    href={`${process.env.REACT_APP_API}/uploads/Categories/${user.certificate_path}`}
    className="resubmit-btn"
    style={{ color: 'white', textDecoration: 'none' }}
  >
    Download
  </a>
)}

        </td>
      </tr>
    ))}
</tbody>



      </table>

      {/* Add User Modal */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            animation: "fadeIn 0.3s ease-in-out",
          }}
        >
          <div
            style={{
              background: "white",
              padding: "20px",
              width: "100%",
              maxWidth: "700px",
              borderRadius: "8px",
              boxShadow: "0 0 15px rgba(0, 0, 0, 0.2)",
              animation: "slideDown 0.3s ease-in-out",
              overflowY: "auto",
              maxHeight: "90vh",
            }}
          >
            <h3>Add Tailoring User</h3>
            <form onSubmit={handleSubmit}>
              {/* First Row: Name, Significant, Father/Husband Name */}
              <div
                style={{ display: "flex", gap: "15px", marginBottom: "15px" }}
              >
                <div style={{ flex: 1 }}>
                  <label style={{ fontWeight: "bold" }}>Name</label>
                  <input
                    type="text"
                    name="name"
                    placeholder="Enter Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                     className="inputStyle"
                  />
                </div>

                <div style={{ flex: 1 }}>
                  <label style={{ fontWeight: "bold" }}>Relationship </label>
                  <select
                    name="relationship"
                    value={formData.relationship}
                    onChange={handleChange}
                    required
                    className="inputStyle"
                  >
                    <option value="">Select</option>
                    <option value="Father">Father</option>
                    <option value="Husband">Husband</option>
                    {/* <option value="Ms">Ms</option> */}
                  </select>
                </div>

                <div style={{ flex: 1 }}>
                  <label style={{ fontWeight: "bold" }}>
                    Father or Husband Name
                  </label>
                  <input
                    type="text"
                    name="fatherHusbandName"
                    placeholder="Enter Name"
                    value={formData.fatherHusbandName}
                    onChange={handleChange}
                    required
                     className="inputStyle"
                  />
                </div>
              </div>

              {/* Two-Column Layout for Remaining Fields */}
        <div style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>
      {[
        { label: "Aadhar Number", name: "aadharNumber", required: true },
        { label: " Door No", name: "doorNumber", required: true },
        { label: "Street Name", name: "streetName", required: true },
        { label: "Postal Area", name: "postalArea", required: true },
        { label: "Pin Code", name: "pinCode", required: true },
        
      ].map((field, index) => (
        <div key={index} style={{ flex: "1 1 calc(50% - 10px)" }}>
          <label style={{ fontWeight: "bold" }}>{field.label}</label>
          <input
            type="text"
            name={field.name}
            placeholder={`Enter ${field.label}`}
            value={formData[field.name]}
            onChange={handleChange}
            required={field.required}
             className="inputStyle"
          />
        </div>


      ))
      
      }  <div style={{ flex: "1 1 calc(50% - 10px)" }}>
                <label style={{ fontWeight: "bold" }}>Photo</label>
                <input
                  type="file"
                  accept="image/*"
                  name="photo"
                  onChange={handleChange}
                  required
                  // style={inputStyle}
                  className="inputStyle"
                />
              </div>

     
     
    </div>
 <div style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>
   {/* District Dropdown */}
      <div style={{ flex: "1 1 calc(50% - 10px)" }}>
        <label style={{ fontWeight: "bold" }}>District</label>
        <select
          name="district"
          value={formData.district}
          onChange={handleChange}
          required
           className="inputStyle"
        >
          <option value="">Select District</option>
          {districts.map((district) => (
            <option key={district.id} value={district.name}>
              {district.name}
            </option>
          ))}
        </select>
      </div>

      {/* Taluk Dropdown */}
      <div style={{ flex: "1 1 calc(50% - 10px)" }}>
        <label style={{ fontWeight: "bold" }}>Taluk</label>
        <select
          name="taluk"
          value={formData.taluk}
          onChange={handleChange}
          required
           className="inputStyle"
        >
          <option value="">Select Taluk</option>
          {taluks.map((taluk) => (
            <option key={taluk.id} value={taluk.name}>
              {taluk.name}
            </option>
          ))}
        </select>
      </div>
 </div>
        {/* Course Name (Dropdown) */}
        <div style={{ marginTop: "15px" }}>
          <label style={{ fontWeight: "bold" }}>Course Name</label>
          <select name="courseName" value={formData.courseName} onChange={handleChange} required  className="inputStyle">
  <option value="">Select</option>
 {
  dropdata && dropdata.map((data, index) => (
    <option key={index} value={data}>{data}</option>
  ))
}

  
</select>

        </div>
        {submitError && (
  <div style={{ color: "red", marginBottom: "10px", fontWeight: "bold" }}>
    {submitError}
  </div>
)}


              {/* File Upload (Full Width) */}
            

              {/* Form Buttons */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <button
                  type="button"
                  onClick={handleCloseModal}
                  style={closeBtnStyle}
                  // className='closeBtnStyle'
                >
                  Close
                </button>
                <button type="submit" className="submitBtnStyle">
                  Pay By Wallet
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

     
{view && (
  <div className="overlay">
    <div className="popup">
      <div className="popup-header">
        <h2 style={{ textAlign: "center", fontSize: "24px", fontWeight: "bold" }}>
          View Tailoring User
        </h2>
        <button className="close-btn" onClick={() => setView(false)}>X</button>
      </div>

      <div className="popup-body">
        <div className="view-grid">
          <div className="view-item">
            <strong>Name:</strong> {viewdatas?.name}
          </div>
          <div className="view-item">
            <strong>Relationship:</strong> {viewdatas?.relationship}
          </div>
          <div className="view-item">
            <strong>Father/Husband Name:</strong> {viewdatas?.fatherHusbandName}
          </div>
          <div className="view-item">
            <strong>Door Number:</strong> {viewdatas?.doorNumber}
          </div>
          <div className="view-item">
            <strong>Street Name :</strong> {viewdatas?.streetName}
          </div>
          <div className="view-item">
            <strong>Pin Code:</strong> {viewdatas?.pinCode}
          </div>
          <div className="view-item">
            <strong>Aadhar Number:</strong> {viewdatas?.aadharNumber}
          </div>
          <div className="view-item">
            <strong>District:</strong> {viewdatas?.district}
          </div>
          <div className="view-item">
            <strong>Taluk:</strong> {viewdatas?.taluk}
          </div>
          <div className="view-item">
            <strong>Course Name:</strong> {viewdatas?.courseName}
          </div>
          <div className="view-item">
            <strong>Photo:</strong>
            <br />
            {viewdatas?.photo ? (
              <img 
                src={`${process.env.REACT_APP_API}/uploads/Categories/${viewdatas?.photo}`} 
                alt="User" 
                className="user-photo"
              />
            ) : (
              "No Photo Available"
            )}
          </div>
        </div>
      </div>

      <div className="popup-footer">
        <button className="close-btn" onClick={() => setView(false)}>Close</button>
      </div>
    </div>
  </div>
)}






{edit && (
  <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0, 0, 0, 0.5)", display: "flex", justifyContent: "center", alignItems: "center" }}>
    <div style={containerStyle}>
      <h3>Edit Tailoring User</h3>
      {editdata.status === 'Re Submit' && (
        <>
        <div >
          <h5><strong>Changes:</strong> <span style={{color:'red'}}>{editdata.description}</span></h5>
        </div>
       </>
      )}

      <form onSubmit={handleupdate}>
        
        {/* Name, Significant, Father/Husband Name */}
        <div style={{ display: "flex", gap: "15px", marginBottom: "15px" }}>
          <div style={{ flex: 1 }}>
            <label>Name</label>
            <input type="text" name="name" value={editdata.name} onChange={handleEditChange} required className="inputStyle" />
          </div>

          <div style={{ flex: 1 }}>
            <label>Significant</label>
            <select name="relationship" value={editdata.relationship} onChange={handleEditChange} required className="inputStyle">
              
               <option value="">Select</option>
                    <option value="Father">Father</option>
                    <option value="Husband">Husband</option>
            </select>
          </div>

          <div style={{ flex: 1 }}>
            <label>Father/Husband Name</label>
            <input type="text" name="fatherHusbandName" value={editdata.fatherHusbandName} onChange={handleEditChange} required className="inputStyle" />
          </div>
        </div>

        {/* Address, Pin Code, Aadhar Number */}
        <div style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>
          {[
             { label: "Aadhar Number", name: "aadharNumber", required: true },
        { label: " Door No", name: "doorNumber", required: true },
        { label: "Street Name", name: "streetName", required: true },
        { label: "Postal Area", name: "postalArea", required: true },
        { label: "Pin Code", name: "pinCode", required: true },
          ].map((field, index) => (
            <div key={index} style={{ flex: "1 1 calc(50% - 10px)" }}>
              <label>{field.label}</label>
              <input type="text" name={field.name} value={editdata[field.name]} onChange={handleEditChange} required={field.required} className="inputStyle" />
            </div>
          ))}
           <div style={{ flex: "1 1 calc(50% - 10px)" }}>
          <label>Photo</label>
          <input type="file" name="photo" accept="image/*" onChange={handleFileChange} className="inputStyle" />
        </div>
          {/* District Dropdown */}
          <div style={{ flex: "1 1 calc(50% - 10px)" }}>
            <label>District</label>
            <select name="district" value={editdata.district} onChange={handleEditChange} required className="inputStyle">
              <option value="">Select District</option>
              {districts.map((district) => (
                <option key={district.id} value={district.name}>
                  {district.name}
                </option>
              ))}
            </select>
          </div>

          {/* Taluk Dropdown */}
          <div style={{ flex: "1 1 calc(50% - 10px)" }}>
            <label>Taluk</label>
            <select name="taluk" value={editdata.taluk} onChange={handleEditChange} required className="inputStyle">
              <option value="">Select Taluk</option>
              {taluks.map((taluk) => (
                <option key={taluk.id} value={taluk.name}>
                  {taluk.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Course Name Dropdown */}
        <div style={{ marginTop: "15px" }}>
          <label>Course Name</label>
      

    <select
  name="courseName"
  value={editdata.courseName}
  onChange={handleEditChange}
  required
  className="inputStyle"
>
  <option value="">Select</option>
  {dropdata &&
    dropdata.map((data, index) => (
      <option key={index} value={data}>
        {data}
      </option>
    ))}
</select>
        </div>

        {/* File Upload */}
       

        {/* Buttons */}
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
          <button type="button" onClick={()=>setedit(!edit)} className="closeBtnStyle">Close</button>
          <button type="submit" className="submitBtnStyle">Submit</button>
        </div>
      </form>
    </div>
  </div>
)}










    </div>
  );
};
const closeBtnStyle = {
  backgroundColor: "#f44336",
  color: "white",
  border: "none",
  padding: "10px 15px",
  cursor: "pointer",
  borderRadius: "5px",
  fontSize: "16px",
};

const containerStyle = {
  background: "white",
  padding: "20px",
  width: "100%",
  maxWidth: "700px",
  maxHeight: "650px", // Set max height
  borderRadius: "8px",
  boxShadow: "0 0 15px rgba(0, 0, 0, 0.2)",
  overflowY: "auto", // Enable vertical scrolling if content exceeds height
};


export default Tailoring;


